import React from 'react';
import '../../../styles/modes/compareMode.css';

const ComparisonResults = ({ 
  pathDifference, 
  autoPathInfo, 
  customPathInfo, 
  expandedDetails, 
  toggleDetails 
}) => {
  if (!pathDifference) return null;

  return (
    <div className="comparison-results">
      <h5>Comparison Results</h5>
      <div className="diff-container">
        <p className="diff-value">
          <span className={pathDifference.isCustomBetter ? 'better' : 'worse'}>
            {pathDifference.isCustomBetter ? 'Saved ' : 'Extra '}
            {pathDifference.absoluteDiff.toFixed(2)} km
            ({Math.abs(pathDifference.percentDiff).toFixed(2)}%)
          </span>
        </p>
        <p className="diff-conclusion">
          {pathDifference.isCustomBetter 
            ? 'Your manual path is better than the algorithm-generated path!' 
            : 'The algorithm-generated path is better than your manual path.'}
        </p>
        
        {/* Display point count difference hint */}
        {autoPathInfo && customPathInfo && autoPathInfo.pointCount !== customPathInfo.pointCount && (
          <p className="point-count-diff">
            <strong>Note:</strong> Auto path has {autoPathInfo.pointCount} points while custom path has {customPathInfo.pointCount} points. Different point counts may affect distance comparison.
          </p>
        )}
        
        {/* Add detailed path comparison button */}
        <button 
          className="toggle-details-btn"
          onClick={toggleDetails}
        >
          {expandedDetails ? 'Hide Detailed Comparison' : 'Show Detailed Comparison'}
        </button>

      </div>
    </div>
  );
};

export default ComparisonResults; 